// Accepts output of useLiveDataTransform, makes it available to children

import React from 'react';
import UseLiveDataTransform from './use-live-data-transform';

const Ctx = React.createContext<Record<string, unknown>>({});

const LiveUpdateProvider = <T extends Record<string, unknown>>({
    children,
    data,
    isPreview,
    isFromMicrosite,
    hasUpdatedFromCs,
}: React.PropsWithChildren<ReturnType<typeof UseLiveDataTransform<T>>>): JSX.Element => {
    const value = React.useMemo(() => ({
        data,
        isPreview,
        isFromMicrosite,
        hasUpdatedFromCs,
    }), [data, isPreview, isFromMicrosite, hasUpdatedFromCs]);
    return (
        <Ctx.Provider value={value}>
            {children}
        </Ctx.Provider>
    );
};

export default LiveUpdateProvider;

export const useLiveUpdateProvider = <T extends Record<string, unknown>>(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    data?: T, // This is used for type inference
    preferInput?: boolean,
): ReturnType<typeof UseLiveDataTransform<T>> => {
    const ctxResult = React.useContext(Ctx) as ReturnType<typeof UseLiveDataTransform<T>>;
    // We use preferInput when data may have already been transformed
    // I.e., within a microsite, where variables may have updated the content,
    // and content has already been combined with drafts input in a parent component (i.e., the franchise-page template)
    if (data && preferInput) {
        return {
            ...ctxResult,
            data,
        };
    }
    return ctxResult;
};
